import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';

@Component({
  selector: 'formly-autocomplete-type',
  template: `
    <input
      matInput
      [matAutocomplete]="auto"
      [formControl]="$any(formControl)"
      [formlyAttributes]="field"
      [placeholder]="to.placeholder"
    />
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      <mat-option *ngFor="let option of filter | async" [value]="option.value">
        {{ option.label }}
      </mat-option>
    </mat-autocomplete>
  `,
})
export class AutocompleteTypeComponent extends FieldType implements OnInit {
  filter: Observable<any[]>;

  ngOnInit() {
    this.filter = this.formControl.valueChanges.pipe(
      startWith(''),
      switchMap((term) => this.filterOptions(term))
    );
  }

  filterOptions(value: string): Observable<any[]> {
    if (!value) {
      return new Observable((observer) => {
        observer.next(this.getOptions());
        observer.complete();
      });
    }

    const filterValue = typeof value === 'string' ? value.toLowerCase() : '';
    const filteredOptions = this.getOptions().filter((option: any) =>
      option.label.toLowerCase().includes(filterValue)
    );

    return new Observable((observer) => {
      observer.next(filteredOptions);
      observer.complete();
    });
  }

  getOptions(): any[] {
    return Array.isArray(this.to.options) ? this.to.options : [];
  }

  displayFn = (value: any): string => {
    if (!value) {
      return '';
    }
    const option = this.getOptions().find((opt: any) => opt.value === value);
    return option ? option.label : value;
  };
}
